import React, { useEffect, useState } from 'react';
import { Drawer, Input, Select, Space, Table, Tag, Tooltip, Typography, message } from 'antd';
import apiClient from '../../../shared/services/apiClient';

const { Text } = Typography;
const FILTERS = [
    { value: '', label: '全部' },
    { value: 'opened', label: '已打开' },
    { value: 'not_opened', label: '未打开' },
    { value: 'clicked', label: '已点击' },
    { value: 'unsubscribed', label: '已退订' },
    { value: 'failed', label: '发送失败' },
];
const TM_STATUS = {
    delivered: ['green', '已送达'],
    queued: ['blue', '排队中'],
    deferred: ['orange', '延迟重试'],
    bounced: ['red', '退信'],
    complained: ['red', '投诉'],
    rejected: ['red', '被拒'],
    failed: ['red', '失败'],
};
const DELIVERY = {
    pending: ['blue', '排队中'],
    sending: ['blue', '发送中'],
    sent: ['default', '已交发信服务'],
    failed: ['red', '发送失败'],
    skipped: ['default', '未发邮件'],
};

function deliveryTag(r) {
    if (!r.delivery_status) return <Text type="secondary">未发邮件</Text>;
    const [color, label] = (r.delivery_status === 'sent' && TM_STATUS[r.tm_status]) || DELIVERY[r.delivery_status] || ['default', r.delivery_status];
    const tag = <Tag color={color}>{label}</Tag>;
    return r.delivery_error ? <Tooltip title={r.delivery_error}>{tag}</Tooltip> : tag;
}

function event(at, count, tracked) {
    if (at) return <Tooltip title={`${count} 次`}>{at}</Tooltip>;
    return tracked ? <Text type="secondary">-</Text> : <Text type="secondary">未追踪</Text>;
}

/** Who a flow was sent to, with delivery, open, click and unsubscribe per person. */
export default function MarketingFlowRecipients({ flow, onClose }) {
    const [query, setQuery] = useState({ page: 1, size: 20, filter: '', q: '' });
    const [data, setData] = useState({ total: 0, items: [] });
    const [loading, setLoading] = useState(false);
    const flowId = flow?.id;

    useEffect(() => {
        setQuery({ page: 1, size: 20, filter: '', q: '' });
    }, [flowId]);

    useEffect(() => {
        if (!flowId) return undefined;
        let stale = false;
        setLoading(true);
        apiClient.get(`/api/admin/marketing-flows/${flowId}/recipients`, { params: query })
            .then((r) => { if (!stale) setData(r.data?.data || { total: 0, items: [] }); })
            .catch((e) => { if (!stale) message.error(e.response?.data?.error || e.response?.data?.message || '加载失败'); })
            .finally(() => { if (!stale) setLoading(false); });
        return () => { stale = true; };
    }, [flowId, query]);

    const columns = [
        {
            title: '用户', render: (_, r) => (
                <Space direction="vertical" size={0}>
                    <Text>{r.email || '-'}</Text>
                    <Text type="secondary" style={{ fontSize: 12 }}>#{r.user_id} {r.username}</Text>
                </Space>
            ),
        },
        { title: '发送时间', dataIndex: 'sent_at', width: 170 },
        { title: '投递', width: 120, render: (_, r) => deliveryTag(r) },
        { title: '打开', width: 170, render: (_, r) => event(r.opened_at, r.open_count, r.tracked) },
        { title: '点击', width: 170, render: (_, r) => event(r.clicked_at, r.click_count, r.tracked) },
        { title: '退订', dataIndex: 'unsubscribed_at', width: 170, render: (v) => v || <Text type="secondary">-</Text> },
    ];

    return (
        <Drawer open={!!flow} onClose={onClose} width="min(1100px, 100vw)" title={flow ? `收件人：${flow.name}` : ''}>
            <Space wrap style={{ marginBottom: 12 }}>
                <Select style={{ width: 130 }} options={FILTERS} value={query.filter} onChange={(filter) => setQuery((s) => ({ ...s, filter, page: 1 }))} />
                <Input.Search allowClear placeholder="邮箱 / 用户名 / ID" style={{ width: 240 }} onSearch={(q) => setQuery((s) => ({ ...s, q, page: 1 }))} />
            </Space>
            <Table rowKey="user_id" size="small" loading={loading} columns={columns} dataSource={data.items} scroll={{ x: 900 }}
                pagination={{
                    current: query.page, pageSize: query.size, total: data.total, showTotal: (t) => `共 ${t} 人`,
                    onChange: (page, size) => setQuery((s) => ({ ...s, page, size })),
                }} />
        </Drawer>
    );
}
